export default __webpack_public_path__ + "static/concrete-driveway-removal-icon-d76fb6ce85fb2d7ecb46c9cff5f41fbe.png";